exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".clipped-image {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden; }\n", ""])